<div class="container-fluid">
  <div class="header-container">
    <div class="page-header">
      <span class="fa fa-id-badge"></span>{{ "bikeshop.menu.online_widget" | translate }}
    </div>
  </div>
  <div>

  </div>

</div>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>